export const W_NS =
  "http://schemas.openxmlformats.org/wordprocessingml/2006/main";

export function wAttr(el: Element, localName: string): string | null {
  return (
    el.getAttribute(`w:${localName}`) ??
    el.getAttributeNS(W_NS, localName) ??
    el.getAttribute(localName)
  );
}

export function firstChildNS(
  parent: Element,
  localName: string,
): Element | null {
  for (let i = 0; i < parent.childNodes.length; i++) {
    const node = parent.childNodes[i];
    if (node instanceof Element && node.localName === localName) {
      return node;
    }
  }
  return null;
}

export function collectParagraphElements(doc: Document | Element): Element[] {
  if (typeof doc.getElementsByTagNameNS === "function") {
    return Array.from(doc.getElementsByTagNameNS(W_NS, "p"));
  }
  return Array.from(doc.getElementsByTagName("w:p"));
}

export function paragraphPlainText(pEl: Element): string {
  const parts: string[] = [];
  const texts = pEl.getElementsByTagNameNS(W_NS, "t");
  if (texts.length) {
    for (let i = 0; i < texts.length; i++) {
      parts.push(texts[i].textContent ?? "");
    }
    return parts.join("");
  }
  for (let i = 0; i < pEl.getElementsByTagName("*").length; i++) {
    const el = pEl.getElementsByTagName("*")[i];
    if (el.localName === "t") parts.push(el.textContent ?? "");
    if (el.localName === "tab") parts.push("\t");
  }
  return parts.join("");
}

export function parseXml(xml: string): Document {
  return new DOMParser().parseFromString(xml, "application/xml");
}

export function isParseError(doc: Document): boolean {
  return !!doc.querySelector("parsererror");
}
